import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";
import { secureStorage } from "../../utils/secureStorage";
import userGlobalConfig from "../../constants/globalConfig";

export const useGetProfile = (): QueryReturnType<any> => {
  // Determine which endpoint to use based on user role
  const getUserRole = () => {
    try {
      const adminDetails = secureStorage.getItem(userGlobalConfig.ADMIN_DETAILS);
      if (adminDetails) {
        const details = JSON.parse(adminDetails);
        return details?.role;
      }
    } catch (error) {
      console.error('Error parsing admin details:', error);
    }
    return null;
  };

  const userRole = getUserRole();
  const isKeyHost = userRole === 'KEY_HOST';
  
  // Use key host endpoint for key hosts, admin endpoint for admins
  const endpoint = isKeyHost ? 'v2/api/keyHost/getProfileData' : ENDPOINTS.GET_PROFILE;

  return useQuery<never, never, any>([endpoint], {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      enabled: !!userRole, // Only run query if we have a user role
    notifyOnChangeProps: [
      "data",
      "error",
      "refetch",
      "isRefetching",
      "isSuccess",
      "isLoading",
    ],
  });
};
